import { PassProductListPicker } from "../../pages/Pass/components/SelectOptionSection/PassProductListPicker";
import { PA_NAME } from "../../types/product-attribute/product-attribute";
import { QuantityBookCardSection } from "../detail/QuantityBookCardSection";
import { ProdAttrCalendarPicker } from "./ProdAttrCalendarPicker";
import { ProdAttrOfMUSICAL } from "./ProdAttrOfMUSICAL";
import ProdAttrOfSIM from "./ProdAttrOfSIM";
import { ProdAttrSingleCheckbox } from "./ProdAttrSingleCheckbox";

export const ProdAttrPicker = (props: ProdAttrPickerModeProps) => {
  const productType = props.d?.productType;
  const { mode } = props;

  return (
    <div
      className={
        mode === "POPUP"
          ? ""
          : "product-attr-picker rounded-[1rem] border border-[#D7DCE3] bg-[#F7F8FA] p-4 pb-10 sm:p-6"
      }
    >
      <div className="select-option">
        {props?.calendarOnly ? (
          <ProdAttrCalendarPicker {...props} />
        ) : (
          <>
            <QuantityBookCardSection {...props} type="CARD" />
            <ProdAttrSingleCheckbox
              names={PA_NAME.VISIBLE_CHECKBOX}
              {...props}
            />
            {productType !== "SIM" && <ProdAttrCalendarPicker {...props} />}
            {/* <ProdAttrDropOff {...props} /> */}
            {productType === "MUSICAL" && <ProdAttrOfMUSICAL {...props} />}
            {productType === "SIM" && <ProdAttrOfSIM {...props} />}
            {/* {renderOptions()} */}
            {productType === "PASS" && <PassProductListPicker {...props} />}
            {productType === "SIM" && <ProdAttrCalendarPicker {...props} />}
          </>
        )}
      </div>
    </div>
  );
};
